import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PersonIcon from "@mui/icons-material/Person";
import { Box, CardContent, Chip, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import type { PackageResponse } from "../../admin/packages/packagesApi";
import type { ECommerceOfferResponse } from "../../eCommerce/eCommerceApi";
import { packageCountries, packageGroupTypes } from "../../publicPackages2/packageTagsInfo";
import { TransportationName } from "../../publicPackages2/transportation";

interface Props {
  readonly offer: ECommerceOfferResponse;
  readonly packageData: PackageResponse;
}

const ECommerceOfferSubheader: FC<Props> = ({ offer, packageData }) => {
  return (
    <CardContent sx={{ p: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="subtitle2"
          color="textSecondary"
          sx={{ mb: 2, letterSpacing: 1, fontWeight: "bold", textTransform: "uppercase" }}
        >
          Kategorie i grupy docelowe
        </Typography>
        <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1 }}>
          {packageCountries(offer).map((c) => (
            <Chip key={c} label={c} color="primary" />
          ))}
          {packageGroupTypes(offer).map((g) => (
            <Chip key={g} label={g} variant="outlined" />
          ))}
        </Stack>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography
          variant="subtitle2"
          color="textSecondary"
          sx={{ mb: 2, letterSpacing: 1, fontWeight: "bold", textTransform: "uppercase" }}
        >
          <InfoOutlinedIcon fontSize="small" sx={{ verticalAlign: "text-bottom", mr: 1 }} />
          Opis oferty
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8, color: "text.primary", fontSize: "1.05rem", maxWidth: 900 }}>
          {packageData?.description}
        </Typography>
        <Stack direction="row" spacing={3} sx={{ mt: 3, flexWrap: "wrap" }} useFlexGap>
          <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
            <AccessTimeIcon color="primary" fontSize="small" />
            <Typography variant="body2" sx={{ fontWeight: "500" }}>
              {packageData?.days.length ?? "-"} dni{" "}
            </Typography>
          </Stack>
          <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
            <DirectionsBusIcon color="primary" fontSize="small" />
            <Typography variant="body2" sx={{ fontWeight: "500" }}>
              {<TransportationName forPackage={offer} />}
            </Typography>
          </Stack>
          <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
            <PersonIcon color="primary" fontSize="small" />
            <Typography variant="body2" sx={{ fontWeight: "500" }}>
              do {offer.participantsNumber.numberOfPaid} osób
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </CardContent>
  );
};

export default ECommerceOfferSubheader;
